import React, { useEffect, useState } from 'react';
import { Menu, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import menu from '../../../shared/data/menu.json';
import design from '../../../assets/icons/design/02.svg';
import structure from '../../../assets/icons/structure/02.svg';
import company from '../../../assets/icons/company/02.svg';

// import './styles.css';

const loadEntries = (entries) => Promise.all(entries.map((entry) => import(`../../../assets/icons${entry.icon}`)));

export default function MainMenu(props) {
    const [image, setImage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        var items = [];
        menu.map(page => pageRecurive(page, items));
        loadEntries(items)
            .then((entries) => {
                var image = {};
                for (let index = 0; index < items.length; index++) {
                    image[items[index].key] = entries[index].default;
                }
                setImage(image);
            });
    }, []);

    const getIcon = (key) => {
        return image === undefined ?
            <span style={{ padding: '0px 8px' }}></span> :
            <img height={18} src={image[key]} alt="img" className='align-middle' />
    }

    const pageRecurive = (item, items) => {
        items.push({
            key: item.key,
            icon: item.icon
        });

        if (item.children?.length > 0) {
            item.children?.map(page => pageRecurive(page, items));
        }
    };

    const menuRecursive = (item) => {
        if (item.children?.length === 0) {
            return {
                key: item.key,
                icon: getIcon(item.key),
                label: item.name,
                onClick: () => navigate(item.route)
            }
        }
        else
            return {
                key: item.key,
                icon: getIcon(item.key),
                label: item.name,
                onClick: () => navigate(item.route),
                children: item.children?.map(page => menuRecursive(page))
            }
    };

    return (
        <Menu
            mode='inline'
            theme="dark"
            items={
                [
                    ...menu.map(page => menuRecursive(page)),
                    {
                        key: 'Configuración',
                        label: (<Typography.Text strong style={{ color: '#fff' }}>Configuración</Typography.Text>),
                        className: 'mt-25 mb-10'
                    },
                    {
                        key: 'display',
                        icon: <img height={18} src={design} alt="img" className='align-middle' />,
                        label: 'Diseño y Visualización',
                        onClick: () => navigate('/design')
                    },
                    // {
                    //     key: 'structure',
                    //     icon: <img height={18} src={structure} alt="img" className='align-middle' />,
                    //     label: 'Estructura de Sitio'
                    // },
                    {
                        key: 'information',
                        label: (<Typography.Text strong style={{ color: '#fff' }}>Información</Typography.Text>),
                        className: 'mt-25 mb-10'
                    },
                    {
                        key: 'company',
                        icon: <img height={18} src={company} alt="img" className='align-middle' />,
                        label: 'Mi Empresa',
                        onClick: () => navigate('/my-company')
                    }
                ]
            }
        />
    );
}